document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-htc-hero]').forEach((hero) => {
    const slides = [...hero.querySelectorAll('[data-htc-slide]')];
    const dots = [...hero.querySelectorAll('[data-htc-dot]')];
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    const delay = Number(hero.dataset.autoplay || 0) * 1000;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((s,i)=>s.classList.toggle('is-active',i===index));
      dots.forEach((d,i)=>d.classList.toggle('is-active',i===index));
    };
    dots.forEach((d,i)=>d.addEventListener('click',()=>{show(i); restart();}));
    const restart=()=>{if(timer)clearInterval(timer);if(delay>0)timer=setInterval(()=>show(index+1),delay)};
    show(0); restart();
  });
});
document.addEventListener('click', function (event) {
  const trigger = event.target.closest('.htc-review__image-button');
  const lightbox = document.getElementById('htc-review-lightbox');

  if (!lightbox) return;

  const image = lightbox.querySelector('.htc-review-lightbox__image');
  const closeButton = lightbox.querySelector('.htc-review-lightbox__close');

  if (trigger) {
    image.src = trigger.dataset.reviewImage;
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    return;
  }

  if (event.target === lightbox || event.target === closeButton) {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    image.src = '';
    document.body.style.overflow = '';
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  const lightbox = document.getElementById('htc-review-lightbox');

  if (!lightbox || !lightbox.classList.contains('is-open')) return;

  const image = lightbox.querySelector('.htc-review-lightbox__image');

  lightbox.classList.remove('is-open');
  lightbox.setAttribute('aria-hidden', 'true');
  image.src = '';
  document.body.style.overflow = '';
});